import { render } from "./envelope-open.vue?vue&type=template&id=742782a6"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/envelope-open.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "742782a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('742782a6', __exports__)) {
    api.reload('742782a6', __exports__)
  }
  
  module.hot.accept("./envelope-open.vue?vue&type=template&id=742782a6", () => {
    api.rerender('742782a6', render)
  })

}


export default __exports__